export const isProduction = process.env.NEXT_PUBLIC_ENVIRONMENT === "production";
